module.exports = __webpack_public_path__ + "img/skip4_p.0cbc8af9.svg";